import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SessionRoutingModule } from './session-routing.module';
import { SessionManagementComponent } from './pages/session-management/session-management.component';
import { SharedModule } from '../shared/shared.module';
import { SessionFilterComponent } from './components/session-filter/session-filter.component';

import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SessionListComponent } from './components/session-list/session-list.component';
import { SessionDetailComponent } from './components/session-detail/session-detail.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { AdminModule } from '../../admin/admin.module';

@NgModule({
  declarations: [
    SessionManagementComponent,
    SessionFilterComponent,
    SessionListComponent,
    SessionDetailComponent,
  ],
  imports: [
    CommonModule,
    SessionRoutingModule,
    SharedModule,

    MatCardModule,
    MatTabsModule,
    MatGridListModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    MatInputModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    AdminModule
  ],
  providers: [
    MatDatepickerModule
  ]
})
export class SessionModule {}
